<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CCdS0p/tc-custom/9781488062902.jpg?1704279093206" alt="This image is the cover for the book After Hours Seduction, The Men of Stone River"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">After Hours Seduction, The Men of Stone River
      </h1>
      <p class="bookDescription body article font2">
        <p>Long hours alone with her ex.  What could go wrong?  Wanting him was a mistake,  And still she said yes…  When Katie Duncan agrees to work with her boss’s brother, she knows she’s stepping into the lion’s den. The man she’ll be living with is her former lover, billionaire Quinten Stone. Their passion sizzled until Katie couldn’t accept Quinten’s wealthy world. She’d walked away to save herself. Now the alpha CEO is back in her life, tempting as ever…and hell-bent on seducing Katie back into his bed…  USA TODAY Bestselling Author</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janice Maynard
      </h2>
      
      <p class="authorDescription body article"><I>USA TODAY</I> bestselling author Janice Maynard loved books and writing even as a child. Now, creating sexy, character-driven romances is her day job! She has written more than 75 books and novellas which have sold, collectively,&#160;almost three million copies. Janice lives in the shadow of the Great Smoky Mountains with her husband, Charles. They love hiking, traveling, and spending time     with family. <Br><Br>Connect with Janice at www.JaniceMaynard.com and on all&#160;socials.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f7e497d2